angular.module 'zc.masterApi'

.factory "MasterCampaignStats", ($q, Facade, CampaignStats, lib) ->

  class MasterCampaignStats

    constructor: (@dimension) ->

    find: (params) ->
      d = $q.defer()
      Facade.request "/master/campaign_stats/#{@dimension}", {
        params:
          json: params
        transformResponse: @transformCampaignStats
      }
      .then (res) =>
        d.resolve res.data.campaign_stats
      d.promise

    aggregate: (params) ->
      d = $q.defer()
      Facade.request "/master/campaign_stats/#{@dimension}/aggregate", {
        params:
          json: params
        transformResponse: @transformCampaignStats
      }
      .then (res) =>
        d.resolve res.data.campaign_stats
      d.promise

    transformCampaignStats: (json) ->
      try
        data = angular.fromJson json
        for stats in data.campaign_stats
          if stats.delivery_count is 0
            stats.conversion_rate = 0
          else
            stats.conversion_rate = stats.conversion_count / stats.delivery_count
          if stats.conversion_count is 0
            stats.average_conversion_price = 0
            stats.campaign_coupon_used_rate = 0
          else
            stats.average_conversion_price = stats.conversion_price / stats.conversion_count
            stats.campaign_coupon_used_rate = stats.campaign_coupon_used_count / stats.conversion_count

        {success: true, campaign_stats: data.campaign_stats}
      catch
        {}

    @statsById: (campaign_stats) ->
      statsById = {}
      for stats in campaign_stats
        statsById[stats.campaign_id] = defaultStats() unless statsById[stats.campaign_id]
        group = if stats.is_control then 'control' else 'experimental'
        statsById[stats.campaign_id][group] = stats
      statsById

    @calculate: (stats) ->
      # lift rate
      if stats.experimental.conversion_rate is 0
        stats.conversion_lift_rate = 0
      else
        stats.conversion_lift_rate = (stats.experimental.conversion_rate - stats.control.conversion_rate) / stats.experimental.conversion_rate
      if stats.control.conversion_rate is 0
        stats.conversion_up_rate = 0
      else
        stats.conversion_up_rate = stats.experimental.conversion_rate / stats.control.conversion_rate
      # price up rate
      if stats.control.average_conversion_price is 0
        stats.price_up_rate = 0
      else
        stats.price_up_rate = stats.experimental.average_conversion_price / stats.control.average_conversion_price
      stats.contribution_price = _.max [lib.truncateFraction(stats.conversion_lift_rate * stats.experimental.conversion_price), 0]
      stats.contribution_count = _.max [lib.truncateFraction(stats.conversion_lift_rate * stats.experimental.conversion_count), 0]
      # control percent
      stats.control_percent = controlPercent stats

    @chisq: (stats, control_percent) ->
      # chisq p
      stats.chisq_p = CampaignStats.chisqP stats
      # control percent chisq p
      stats.control_percent_chisq_p = controlPercentChisqP stats, control_percent

    defaultStats = ->
      control:
        delivery_count: 0
        conversion_count: 0
        conversion_price: 0
        conversion_rate: 0
        average_conversion_price: 0
        campaign_coupon_used_count: 0
        campaign_coupon_used_rate: 0
      experimental:
        delivery_count: 0
        conversion_count: 0
        conversion_price: 0
        conversion_rate: 0
        average_conversion_price: 0
        campaign_coupon_used_count: 0
        campaign_coupon_used_rate: 0

    controlPercent = (stats) ->
      total_delivery_count = stats.experimental.delivery_count + stats.control.delivery_count
      return 0 if total_delivery_count is 0
      stats.control.delivery_count / total_delivery_count * 100

    controlPercentChisqP = (stats, control_percent) ->
      ZCStats.chisqdist 1, controlPercentChisq(stats, control_percent)

    controlPercentChisq = (stats, control_percent) ->
      total_delivery_count = stats.experimental.delivery_count + stats.control.delivery_count
      control_expectation = total_delivery_count * control_percent / 100
      return 0 if control_expectation is 0
      experimental_expectation = total_delivery_count - control_expectation
      return 0 if experimental_expectation is 0
      experimental = ((stats.experimental.delivery_count - experimental_expectation) ** 2) / experimental_expectation
      control = ((stats.control.delivery_count - control_expectation) ** 2) / control_expectation
      experimental + control

  MasterCampaignStats



// WEBPACK FOOTER //
// ./src/master_admin_modules/master_api/facade/master_campaign_stats.service.coffee